import type { SVGProps } from "react";
export const ChevronLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.606 6.251a.857.857 0 0 1 0 1.212L11.07 12l4.537 4.537a.857.857 0 1 1-1.212 1.212L9.25 12.606a.857.857 0 0 1 0-1.212l5.143-5.143a.857.857 0 0 1 1.212 0"
      clipRule="evenodd"
    />
  </svg>
);
